<template>
    <div>
      <div class="seachBox flex">
            <div class="seachList"><span class="name">客户名称：</span>
              <a-select
                  placeholder="请输入客户名称"
                  v-model="seach.id" class="seachs"
                  :default-active-first-option="false"
                  :filter-option="false"
                  :not-found-content="null"
                  :options="options"
                  :show-arrow="false"
                  show-search
                  @search="handleSearch"
                  @change="getList(1)"
              >
              </a-select>
            </div>
        </div>
      <div v-if="loading==false">
  <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false" rowKey="id"></a-table>
  <h1>新增导入 <a-button class="top_btn" type="primary" @click="()=>{visible = true; }">导入</a-button></h1>
  <h1>导入日志</h1>
  <a-table :columns="columns2" :data-source="data2" :loading="loading" :pagination="false" rowKey="id">
        <span slot="status" slot-scope="text, record">{{record.status_text}}
<!--            <a-popconfirm-->
<!--                title="是否重新提交？"-->
<!--                ok-text="确定"-->
<!--                cancel-text="取消"-->
<!--                @confirm="addAlibaba(record)"-->
<!--                @cancel="()=>{}"-->
<!--            >-->
<!--    <a v-if="record.status==3">重新提交</a>-->
<!--  </a-popconfirm>-->

        </span>
  </a-table>
</div>
      <a-modal
          title="导入阿里产品"
          :visible="visible"
          @ok="addAlibaba()"
          @cancel="cancelAL"
      >
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
          <a-form-model-item
              ref="store_url"
              label="店铺地址"
              prop="store_url"
              :help="formErr.store_url"
              :validateStatus='!formErr.store_url||formErr.store_url==""?"":"error"'
          >
            <a-input
                :maxLength=255
                placeholder="http://"
                v-model="form.store_url"
                @change="(e) => { formErr.store_url=''}"
                @blur="(e) => { form.store_url = e.target.value.trim() }"
            />
          </a-form-model-item>
        </a-form-model>
        <div style="position: relative">
          <span style="position: absolute;top: 0;left: 0">注：</span>
          <div style="padding-left: 30px">1.请输入阿里店铺链接地址:店铺首页或productlist页面</div>
          <div style="padding-left: 30px">2.导入后图片水印跟随用户后台“产品管理-水印设置”，如果不想添加水印，请关闭水印，如果想要添加水印，请开启并上传水印</div>
        </div>

      </a-modal>
    </div>

</template>

<script>
    import API from "./api";
    import moment from 'moment';
    import AgentForm from "./components/agentForm"
    import {changStatus, removeById, orderList, debounce, validator} from "../../../utils/utils"
    const columns = [

        {
            title: "客户名称",
            dataIndex: "company",
            ellipsis: true,
            key: "company",
        },
        {
            title: "手机号",
            dataIndex: "mobile",
            ellipsis: true,
            key: "mobile",
          scopedSlots: {customRender: "mobile"}
        },
        {
            title: "网址",
            dataIndex: "domain",
            ellipsis: true,
            key: "domain",scopedSlots: {customRender: "domain"}
        },
    ];
    const columns2 = [
      {
        title: "导入内容",
        dataIndex: "store_url",
        ellipsis: true,
        key: "store_url",
      },
      {
        title: "提交时间",
        dataIndex: "commit_time",
        ellipsis: true,
        key: "commit_time",
        scopedSlots: {customRender: "commit_time"}
      },
      {
        title: "导入完成时间",
        dataIndex: "finish_time",
        ellipsis: true,
        key: "finish_time",scopedSlots: {customRender: "finish_time"}
      },
      {
        title: "状态",
        dataIndex: "status_text",
        ellipsis: true,
        key: "status_text",scopedSlots: {customRender: "status"}
      },
      {
        title: "导入数量",
        dataIndex: "import_num",
        ellipsis: true,
        key: "import_num",scopedSlots: {customRender: "import_num"}
      },
    ];
    export default {
        name: "index",
        data() {
            return {
              layout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 18 },
              },
                resetSeachdata:true,
                fieldNames: {label: 'name', value: 'id', children: 'children'},
                visibleImg: false,
              store_url: "",
              form: {
                store_url:""
              },
              formErr: {
                store_url:""
              },
              rules: {
                store_url: [{required: true, message: "请输入店铺地址", trigger: "blur"},{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.store_url)}  , trigger: "blur"  }, ],
              },
                options:[],
                seach: {id: undefined,},
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                data: [],
                data2: [],
                columns,
                columns2,
                loading: true,
                visible: false,
                title: "",
                editId: null
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/Agent/AgentList"; //设置左侧导航2-2 active
        },
        mounted() {
        },
        components: {AgentForm},
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
          cancelAL() {
            this.visible=false;
            if(this.$refs.ruleForm) this.$refs.ruleForm.resetFields();},
          addAlibaba(record) {
            let _that=this
            if(record) {
              API.service.SUBMIT_ADD({ store_url: record.store_url , a_customer_id:this.seach.id}).then(res => {
                this.getList()
              })
            }  else{
              this.$refs.ruleForm.validate(valid => {
                if (valid) {
                  API.service.SUBMIT_ADD({store_url: this.form.store_url, a_customer_id: this.seach.id}).then(res => {
                    if (res.data.code === 400) {
                      res.data.msg.map((item, index) => {
                        _that.formErr[item.field] = item.msg
                      })
                    } else {
                      this.getList()
                    }
                  })
                }
              })
            }
            },

          handleSearch: debounce(function (val)   {
            this.handleSearchFn(val)
          }, 300),
          handleSearchFn(val){
            console.log(val)
            this.options=[];
            // this.seachList.name=[]
            //下拉模糊查询
            if(val){this.getSeachList(val)}

          },
          getSeachList(company){
            API.service.GET_NAME({company}).then(res => {
              // this.seachList.name = res.data.data
              res.data.data.forEach((item) => {
                this.options.push({
                  value: item.id,
                  label: item.company,
                })
              });
            })
          },
            getList(page) {
                let seachData = JSON.parse(JSON.stringify(this.seach))
                API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.data =[res.data.data]
                    this.loading = false
                })
              API.service.GET_RECORD({page: page || 1, a_customer_id:this.seach.id}).then(res => {
                this.data2 =res.data.data
                this.loading = false
              })
              this.visible=false;
              this.$refs.ruleForm?.resetFields();
            },
        }
    }
</script>

<style scoped>
    .seachBox .seachList .name {width: 70px !important;}
    .seachBox .seachList .seachs {width: calc(100% - 80px);}
    .inputs {display: inline-block;width: 70px}
     h1{font-size: 16px;font-weight: bold}
    .ant-table-body{min-height: unset!important;}
</style>
